import { render, staticRenderFns } from "./TeclabReenrollmentBanners.vue?vue&type=template&id=21fdc450"
import script from "./TeclabReenrollmentBanners.vue?vue&type=script&lang=js"
export * from "./TeclabReenrollmentBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports